import React from 'react';
import {
  ProcessSection,
  SectionHeading,
  ProcessGrid,
  ProcessItem,
  ProcessNumber,
} from './Process.styles.jsx';

const Process = () => {
  return (
    <ProcessSection>
      <SectionHeading $center>
        <p className="eyebrowHeader">How It Works</p>

        <h2>A Straightforward Safety Audit Process</h2>

        <p>
          We work with your organization to understand your workplace, review
          your current safety program, and communicate the findings clearly.
        </p>
      </SectionHeading>

      <ProcessGrid>
        <ProcessItem>
          <ProcessNumber>01</ProcessNumber>

          <h3>Discuss Your Workplace</h3>

          <p>
            Start with a conversation about your organization, operations, and
            current safety program.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>02</ProcessNumber>

          <h3>Review the Program</h3>

          <p>
            Examine relevant workplace practices, documentation, procedures, and
            safety systems.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>03</ProcessNumber>

          <h3>Identify Findings</h3>

          <p>
            Highlight strengths, potential gaps, and areas that may benefit from
            further attention.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>04</ProcessNumber>

          <h3>Plan the Next Steps</h3>

          <p>
            Review the findings and use practical recommendations to help guide
            future improvements.
          </p>
        </ProcessItem>
      </ProcessGrid>
    </ProcessSection>
  );
};

export default Process;
